import { render, staticRenderFns } from "./form-demo.vue?vue&type=template&id=4242d6df&scoped=true&"
import script from "./form-demo.vue?vue&type=script&lang=js&"
export * from "./form-demo.vue?vue&type=script&lang=js&"
import style0 from "./form-demo.vue?vue&type=style&index=0&id=4242d6df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4242d6df",
  null
  
)

export default component.exports